import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { validateYouTubeUrl } from '@/util/utils';
import styles from './Message.module.scss';
export const Video = ({ name, url }) => {
    const { t } = useTranslation();
    const validYoutubeUrl = validateYouTubeUrl(url);
    return (_jsx(_Fragment, { children: validYoutubeUrl ? (_jsx("iframe", { title: name, width: "100%", height: "265", frameBorder: "0", allowFullScreen: true, src: validYoutubeUrl })) : (
        /* eslint-disable-next-line jsx-a11y/media-has-caption */
        _jsxs("video", { className: styles.video, controls: true, title: name, children: [_jsx("source", { src: url, type: "video/mp4" }), _jsx("p", { children: t('no_video_tag') })] })) }));
};
